import { readRedirectUri, SignInPage } from "@acquire-intelligence/ai-labs-auth-component";
import { useLocation } from "react-router-dom";
import { authClient } from "../lib/api";

/**
 * The estate's one sign-in page: the shared SignInPage, the same component
 * every project's local sign-in renders, so the deployed page and the local
 * one cannot drift.
 *
 * redirectUri comes from the router's location rather than the component's
 * own read of window.location: the admin guard sends an unauthenticated
 * visitor here with ?redirect_uri=/admin by client-side navigation.
 */
export function LoginPage() {
  const location = useLocation();
  return (
    <SignInPage
      key={location.search}
      client={authClient}
      redirectUri={readRedirectUri(location.search)}
    />
  );
}
